/**
 * Generates a unique identifier using the Web Crypto API.
 * This function wraps crypto.randomUUID() which generates RFC4122 v4 UUIDs.
 *
 * @returns A unique identifier string in UUID v4 format (e.g., "550e8400-e29b-41d4-a716-446655440000")
 *
 * @example
 * const id = generateId(); // "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d"
 */
export function generateId(): string {
  // Check if crypto.randomUUID is available (modern browsers and Node 16.7.0+)
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  // Fallback: Generate a UUID v4 using Math.random()
  // This follows the RFC4122 specification for UUID v4
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
